import { FolderChip } from '../../../utils/types/candi_bank_types';
export interface Candidate {
  id: string;
  name: string;
  role: string;
  location: string;
  avatar: string;
  skills: string[];
  experience: string;
  status: 'open' | 'active' | 'unavailable';
  matchPercentage: number;
  aiInsight: string;
}

export interface Experience {
  job_title: string;
  company?: string;
  start_date?: string;
  end_date?: string;
  description?: string;
}

export interface CandidateDocument {
  id?: string;
  s3Filename: string;
  requirementKey?: string;
  requirementLabel?: string;
  baseFilename?: string;
  uploadedAt?: number | string;
}

export interface CandidateType {
  id: string;
  name: string;
  avatar: string;
  skills: string[];
  educations: string[];
  work_experience: Experience[];
  /** Null when the list is not ranked (no search text). */
  score: number | null;
  status: string;
  experience: number;
  email: string;
  location?: string;
  phone?: string;
  inviteLists?: string[];
  filename?: string;
  pdfUrl?: string;
  documents?: CandidateDocument[];
  /** Candi Bank folders this person is in. */
  folders?: FolderChip[];
}

export const mockCandidates: Candidate[] = [
  {
    id: '1',
    name: 'Sarah Johnson',
    role: 'Senior Frontend Developer',
    location: 'San Francisco, CA',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&h=387&q=80',
    skills: ['React', 'TypeScript', 'Next.js', 'Tailwind CSS'],
    experience: '5+ years',
    status: 'open',
    matchPercentage: 95,
    aiInsight:
      'Exceptional React expertise with strong TypeScript skills. Perfect match for modern frontend architecture.',
  },
  {
    id: '2',
    name: 'Michael Chen',
    role: 'Full Stack Engineer',
    location: 'Seattle, WA',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&h=387&q=80',
    skills: ['Node.js', 'Python', 'AWS', 'Docker'],
    experience: '7+ years',
    status: 'active',
    matchPercentage: 88,
    aiInsight:
      'Strong backend skills with cloud expertise. Great fit for scalable system development.',
  },
  {
    id: '3',
    name: 'Emily Rodriguez',
    role: 'UX/UI Designer',
    location: 'New York, NY',
    avatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&h=387&q=80',
    skills: ['Figma', 'Adobe XD', 'Prototyping', 'User Research'],
    experience: '4+ years',
    status: 'open',
    matchPercentage: 92,
    aiInsight:
      'Creative design thinking with strong user research background. Ideal for product design roles.',
  },
  {
    id: '4',
    name: 'David Kim',
    role: 'DevOps Engineer',
    location: 'Austin, TX',
    avatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&h=387&q=80',
    skills: ['Kubernetes', 'Jenkins', 'Terraform', 'AWS'],
    experience: '6+ years',
    status: 'open',
    matchPercentage: 90,
    aiInsight:
      'Expert in container orchestration and CI/CD pipelines. Perfect for infrastructure automation.',
  },
  {
    id: '5',
    name: 'Lisa Thompson',
    role: 'Data Scientist',
    location: 'Boston, MA',
    avatar:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&h=387&q=80',
    skills: ['Python', 'Machine Learning', 'TensorFlow', 'SQL'],
    experience: '5+ years',
    status: 'unavailable',
    matchPercentage: 85,
    aiInsight:
      'Strong ML background with practical implementation experience. Great for AI-driven projects.',
  },
  {
    id: '6',
    name: 'James Wilson',
    role: 'Backend Developer',
    location: 'Chicago, IL',
    avatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&h=387&q=80',
    skills: ['Java', 'Spring Boot', 'PostgreSQL', 'Redis'],
    experience: '8+ years',
    status: 'active',
    matchPercentage: 87,
    aiInsight:
      'Solid enterprise Java experience with database optimization skills. Excellent for backend systems.',
  },
];

export const mockNames = [
  'Sarah Johnson', 'Mike Chen', 'Emma Parker', 'David Rodriguez', 'Lisa Wong', 'Alex Thompson',
  'Maria Garcia', 'James Wilson', 'Jennifer Brown', 'Robert Davis', 'Ashley Miller', 'Daniel Garcia',
  'Jessica Martinez', 'Christopher Anderson', 'Amanda Taylor', 'Matthew Thomas', 'Nicole Jackson',
  'Andrew White', 'Stephanie Harris', 'Joshua Martin', 'Melissa Thompson', 'Kevin Garcia',
  'Laura Rodriguez', 'Ryan Lewis', 'Rachel Lee', 'Brandon Walker', 'Kimberly Hall', 'Tyler Allen',
];

export const mockSkills = [
  ['React', 'TypeScript', 'Node.js', 'AWS'],
  ['Python', 'Django', 'PostgreSQL', 'Docker'],
  ['Java', 'Spring Boot', 'Microservices', 'Kubernetes'],
  ['JavaScript', 'Vue.js', 'MongoDB', 'Redis'],
  ['C#', '.NET', 'Azure', 'SQL Server'],
  ['React Native', 'Swift', 'Kotlin', 'Firebase'],
  ['Angular', 'RxJS', 'GraphQL', 'Jest'],
  ['PHP', 'Laravel', 'MySQL', 'Elasticsearch'],
];

export const CANDIDATES_STATS = {
  total: 1247,
  openToRoles: 834,
  recent: 156,
};
